import FeatureFlagsContext from 'context/FeatureFlagsContext';
import { addDays, format, isAfter } from 'date-fns';
import React, { ChangeEvent, useContext } from 'react';
import { Pressable, View } from 'react-native';
import { showFeatureFlag } from 'utils/featureFlagUtils';
import '../park/styles/datePicker.css';
import ValidFromSelector from './ValidFromSelector';

const ValidFromPicker: React.FC<{
  validFrom: Date;
  onConfirm: (date: Date) => void;
  testID: string;
  minDaysBeforeStart?: number;
  minimumDate?: Date | null;
  maxDaysBeforeStart?: number;
  disabled?: boolean;
  mode?: 'date' | 'time' | 'datetime';
  selectedDate: Date;
  vehicleChanged?: boolean;
  hasBeenPressed?: boolean;
  setHasBeenPressed?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  validFrom,
  onConfirm,
  testID,
  minDaysBeforeStart = 0,
  minimumDate,
  maxDaysBeforeStart,
  disabled = false,
  mode = 'date',
  selectedDate,
  vehicleChanged = false,
  hasBeenPressed = false,
  setHasBeenPressed,
}) => {
  const {
    flags: { ltp_buy_schedule },
  } = useContext(FeatureFlagsContext);
  const showDateSelector = showFeatureFlag(ltp_buy_schedule) && !disabled;
  const handleConfirm = (event: ChangeEvent<HTMLInputElement>) => {
    const newDate = new Date(event.target.value);
    const dateAndTime =
      mode === 'date' ? new Date(newDate.setHours(0, 0, 0, 0)) : newDate;
    onConfirm(dateAndTime);
    setHasBeenPressed?.(true);
  };
  const today = new Date();
  const flexibleMinimumDate = addDays(today, minDaysBeforeStart);
  const earliestDate =
    minimumDate && isAfter(minimumDate, flexibleMinimumDate)
      ? minimumDate
      : flexibleMinimumDate;
  const maximumDateBase =
    minimumDate && isAfter(minimumDate, today) ? minimumDate : today;
  const Container = showDateSelector ? Pressable : View;

  return (
    <View>
      <Container testID={`${testID}-day-selection`}>
        <ValidFromSelector
          testID={testID}
          mode={mode}
          value={selectedDate}
          showDateSelector={showDateSelector}
          vehicleChanged={vehicleChanged}
          hasBeenPressed={hasBeenPressed}
        />
        {showDateSelector && (
          <input
            type={mode === 'datetime' ? 'datetime-local' : 'date'}
            className="datepicker-input"
            value={format(validFrom, "yyyy-MM-dd'T'HH:mm")}
            onChange={handleConfirm}
            min={format(earliestDate, 'yyyy-MM-dd')}
            max={
              maxDaysBeforeStart
                ? format(
                    addDays(maximumDateBase, maxDaysBeforeStart),
                    'yyyy-MM-dd'
                  )
                : undefined
            }
            required
          />
        )}
      </Container>
    </View>
  );
};

export default ValidFromPicker;
